import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { ShadowlessInputEl } from "common/components/input";
import { ToastPortalEl } from "common/components/toast-portal";
import { InvisibleSubmit, ReCaptcha } from "common/templates/mixins";
import { AuthContainerEl } from "common/widgets/auth-container";
import { AuthBanners } from "../mixin/auth-banners";
export function template() {
  const {
    error,
    formErrors,
    formValues,
    errorReason,
    isSsoEnabled,
    isSsoRequired,
    magicLinkEmail,
    next,
    notification,
    showMagicLinkConfirmation,
    showPasswordField,
    waitingForResponse
  } = this.state;
  const nextParam = next ? `?next=${encodeURIComponent(next)}` : ``;
  return /* @__PURE__ */ jsx(AuthContainerEl, {
    attrs: {
      "show-footer-links": true
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form",
    attrs: {
      slot: `auth-form-slot`
    }
  }, /* @__PURE__ */ jsx(AuthBanners, {
    error: errorReason || this.attr(`error`),
    info: this.attr(`info-message`)
  }), /* @__PURE__ */ jsx("form", {
    attrs: { id: `mpSignInForm`, method: `post`, action: `/login/` },
    on: { submit: this.helpers.handleFormSubmit }
  }, error && /* @__PURE__ */ jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        message: error,
        type: `error`,
        closeToastCallback: this.helpers.handleToastClosed
      }
    }
  }), notification && /* @__PURE__ */ jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        message: notification,
        type: `success`,
        closeToastCallback: this.helpers.handleToastClosed
      }
    }
  }), showMagicLinkConfirmation && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("h1", {
    sel: ".auth-form-title.center"
  }, "Check your email"), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-copy-content.center"
  }, "We sent a login link to"), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-copy-content-bold.center"
  }, magicLinkEmail), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-copy-content.center"
  }, "Not seeing the email? ", ` `, /* @__PURE__ */ jsx("a", {
    on: { click: this.helpers.handleContinueBtnClick }
  }, "Resend"))), !showMagicLinkConfirmation && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ReCaptcha, {
    recaptchaKey: this.attr(`recaptcha-key`)
  }), /* @__PURE__ */ jsx("h1", {
    sel: ".auth-form-title.center"
  }, "Log in to your account"), this.attr(`enable-google-sign-in`) && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: "#g_id_onload.gid",
    attrs: {
      "data-client_id": this.helpers.getSignInWithGoogleClientId(),
      "data-callback": `handleGoogleCredentialResponse`,
      "data-auto_prompt": `false`
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".g_id_signin",
    attrs: {
      "data-type": `standard`,
      "data-size": `large`,
      "data-theme": `filled_blue`,
      "data-text": `continue_with`,
      "data-shape": `rectangular`,
      "data-logo_alignment": `left`,
      "data-width": 293
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-divider"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-divider-content"
  }, "or log in with email"))), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx(ShadowlessInputEl, {
    attrs: {
      "field-id": `id_email`,
      "field-name": `email`,
      label: `Email Address`,
      placeholder: `e.g. eleanor@mixpanel.com`,
      "validation-status": this.helpers.getValidationStatus(`email`),
      "error-message": formErrors.email
    },
    props: { value: formValues.email },
    on: {
      input: this.helpers.handleEmailInput,
      blur: this.helpers.handleEmailBlur
    }
  })), isSsoEnabled && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".auth-form-field-action-button.sso-button",
    attrs: { size: ButtonSize.Large, theme: ButtonTheme.Primary, elref: `ssoLoginButton` },
    on: { click: this.helpers.handleSsoSignInBtnClick }
  }, "Log in with SSO")), !isSsoRequired && /* @__PURE__ */ jsx("div", {
    sel: ".sign-in-or-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".sign-in-sso-line-separator"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".sign-in-sso-text-separator"
  }, "OR"), /* @__PURE__ */ jsx("div", {
    sel: ".sign-in-sso-line-separator"
  }))), !isSsoRequired && showPasswordField && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(InvisibleSubmit, null), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx(ShadowlessInputEl, {
    attrs: {
      "field-id": `id_password`,
      "field-name": `password`,
      label: `Password`,
      placeholder: `e.g. \u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022`,
      type: `password`,
      "validation-status": this.helpers.getValidationStatus(`password`),
      "error-message": formErrors.password
    },
    props: { value: formValues.password },
    on: { input: this.helpers.handlePasswordInput }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".login-btn",
    attrs: {
      size: ButtonSize.Large,
      theme: isSsoEnabled ? ButtonTheme.Secondary : ButtonTheme.Primary
    },
    on: { click: this.helpers.handleSignInBtnClick }
  }, this.helpers.getLoginButtonLabel())), /* @__PURE__ */ jsx("div", {
    sel: ".mp-sign-in-extra-row"
  }, /* @__PURE__ */ jsx("a", {
    sel: ".auth-link",
    attrs: { href: `/forgot-password/${nextParam}` }
  }, "Forgot Password"))), !isSsoRequired && !showPasswordField && /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-field-row"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".continue-btn",
    attrs: { size: ButtonSize.Large, theme: ButtonTheme.Primary },
    on: { click: this.helpers.handleContinueBtnClick },
    disabled: waitingForResponse
  }, "Continue")), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-footer"
  }, "Don't have an account?", /* @__PURE__ */ jsx("a", {
    attrs: { href: `/register/${nextParam}`, class: `mp-link` },
    style: { "padding-left": `5px` }
  }, "Sign Up")), /* @__PURE__ */ jsx("input", {
    attrs: { name: `next`, type: `hidden`, value: next }
  }), /* @__PURE__ */ jsx("input", {
    attrs: {
      id: `gid-input`,
      name: `social_credential`,
      type: `hidden`
    },
    props: { value: formValues.socialCredential }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-footer.contact-supports"
  }, showMagicLinkConfirmation && `Still not seeing the email? Your account may be associated with a different email.`, !showMagicLinkConfirmation && /* @__PURE__ */ jsx(null, null, "Having trouble logging in?", /* @__PURE__ */ jsx("a", {
    attrs: { href: `/reset-password`, class: `mp-link` },
    on: { click: this.helpers.handleCreatePasswordClick }
  }, ` `, "Click here", ` `), "to set a new password.")), /* @__PURE__ */ jsx("div", {
    sel: ".auth-form-footer.contact-supports"
  }, "If you need help,", ` `, /* @__PURE__ */ jsx("a", {
    attrs: {
      href: `mailto:support@mixpanel.com`,
      class: `mp-link`
    },
    on: { click: this.helpers.handleContactSupportClick }
  }, "contact support"), ".")));
}
